import { api } from "./authService";

export const normalizeAdminApiKeys = (payload) => {
  if (Array.isArray(payload)) return payload;

  const candidates = [
    payload?.api_keys,
    payload?.apiKeys,
    payload?.data,
    payload?.results,
    payload?.items,
    payload?.data?.api_keys,
    payload?.data?.apiKeys,
    payload?.data?.results,
    payload?.data?.items,
  ];

  return candidates.find(Array.isArray) || [];
};

export const normalizeAdminApiKey = (payload) => {
  if (!payload) return null;

  return (
    payload.api_key ||
    payload.apiKey ||
    payload.data?.api_key ||
    payload.data?.apiKey ||
    payload.data ||
    payload
  );
};

export const getAdminApiKeys = async (params = {}) => {
  // Backend paginates with a cursor (next_cursor) and a fixed server-side
  // page size (FETCH_QUERY_LIMIT, 15). Only pass the params it supports.
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const query = searchParams.toString();
  const response = await api.get(`/admin/api-keys${query ? `?${query}` : ""}`);
  return response.data;
};

export const getAdminApiKey = async (id) => {
  const response = await api.get(`/admin/api-keys/${id}`);
  return response.data;
};

export const revokeAdminApiKey = async (id, revokedReason) => {
  const response = await api.patch(`/admin/api-keys/${id}`, {
    status: "revoked",
    revoked_reason: revokedReason,
  });

  return response.data;
};
